export const FirebaseConfig = {
	"projectId": "hiilla-delivery-main-build",
	"appId": "1:850632990211:web:b506e8ba8dbff216d43836",
	"databaseURL": "https://hiilla-delivery-main-build-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "hiilla-delivery-main-build.firebasestorage.app",
	"apiKey": "AIzaSyDj_SNlwAGYi9JrB0zBoioX-C_-j0Ohcho",
	"authDomain": "hiilla-delivery-main-build.firebaseapp.com",
	"messagingSenderId": "850632990211",
	"measurementId": "G-W9BWRNXJC6",
	"projectNumber": "850632990211",
	"version": "2"
};